<template>
  <v-card
    :class="{
      'mobileStyle': $vuetify.breakpoint.xs,
      fixedStyle: (
        $vuetify.breakpoint.sm
        || $vuetify.breakpoint.md
      ),
      largeFixedStyle : $vuetify.breakpoint.lgAndUp
    }"
    class="pb-4"
  >
    <v-card-title class="pb-1">
      <h2 class="playlist-headline font-weight-light">Table of Contents</h2>
      <v-spacer></v-spacer>
      <v-btn
      class="mt-2"
      small
      block
      outlined
      :color="playlist.default_color"
      :disabled="isUpdating || restrictPlaylistAccess || showSlideout"
      @click="addModule"
      aria-label="Add module">
        <v-icon left>mdi-plus-circle-outline</v-icon> Add Module
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div
      id="bulbBoard"
      class="ml-1">
        <draggable
          v-model="modules"
          v-bind="dragOptions"
          group="module"
          :disabled="(
            isUpdating
            || restrictPlaylistAccess
            || showSlideout
          )"
          @update="updateModulesOrder"
        >
          <DraggableModule v-for="module in playlist.modules" :module="module" :key="module.id"></DraggableModule>
        </draggable>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions,
} from 'vuex';
import draggable from 'vuedraggable';
import { mapFields } from 'vuex-map-fields';
import _ from 'lodash';
import DraggableModule from './DraggableModule.vue';

export default {
  name: 'PlaylistPreview',
  components: {
    draggable,
    DraggableModule,
  },
  computed: {
    ...mapState([
      'isUpdating',
      'passbackBulbs',
      'showSlideout',
      'user',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
    ...mapFields([
      'playlist',
      'playlist.modules',
    ]),
    dragOptions() {
      return {
        animation: 150,
        group: 'module',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    ...mapActions([
      'createModule',
      'updatePlaylist',
    ]),
    addModule() {
      const order = this.playlist.modules.length;
      this.createModule({
        order,
        defaultColor: '#2196F3',
        name: `New Module ${order + 1}`,
      });
    },
    updateModulesOrder() {
      const modules = [];
      for (const module of this.playlist.modules) {
        modules.push({
          id: module.id,
          order: _.findIndex(this.playlist.modules, { id: module.id }),
        });
      }
      this.updatePlaylist({
        modules,
      });
    },
  },
};
</script>

<style lang="scss">
  .fixedStyle {
    min-width: 240px;
    width: 25%;
    left: 40px;
    height: calc(100vh - 150px);
    position: fixed !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .largeFixedStyle {
    height: calc(100vh - 150px);
    width: 25%;
    left: 60px;
    position: fixed !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .mobileStyle {
    position: static;
  }
</style>
